import Box from '../Box'
import styled from 'styled-components'

export const Flex = styled(Box)({ display: 'flex' })

export default Flex
